import * as ComponentsDb from '@edit/tree/componentsdb.js';
import IconMapping from '@components/iconMapping.js';

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    treeutil: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    }
  },
  data() {
    const {type} = this.component;
    const dbentry = ComponentsDb.findDbEntry(this.component);
    const icon = IconMapping[type];
    const iconSize = ComponentsDb.iconSize;
    const {toComponents, fromComponents} = this.treeutil.getFromAndToForComponent(this.component);
    return {
      dbentry,
      icon,
      iconSize,
      toComponents,
      fromComponents
    }
  },
  methods: {
    hasSlots(component) {
      const slots = ComponentsDb.createSlots(component, this.partutil, this.transform);
      console.log('slots for', component, 'is', slots);
      return slots.length;
    }
  },
  computed: {
    linkGroups() {
      console.log('have dbentry', this.dbentry);
      const linkGrouping = ComponentsDb.createLinkGrouping(
        this.fromComponents,
        this.dbentry.createLinkTitle
      );
      return linkGrouping;
    }
  },
  watch:{
    // TODO: check performance of this on mobile
    treeutil: {
      handler(nv) {
        console.log('treeutil updated');
        const {toComponents, fromComponents} = this.treeutil.getFromAndToForComponent(this.component);
        this.toComponents = toComponents;
        this.fromComponents = fromComponents;
      },
      deep:true
    }
  }
}
